import { MessageRole } from './message-role.enum';
import { MessageSource } from './message-source.model';

export class Message {
    constructor(message?: string, role?: MessageRole) {
        this.message = message ?? '';
        this.role = role ?? MessageRole.User;
    }

    id = 0;
    role: MessageRole;
    message: string;
    creationDate = new Date();
    error = false;
    data?: any;
    sources?: MessageSource[];

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.role = data.role ?? MessageRole.User;
        this.message = data.message ?? '';
        this.creationDate = data.creation_date ? new Date(data.creation_date) : new Date();
        this.data = data.data ?? undefined;
        this.sources = data.sources?.map((source: MessageSource) => new MessageSource().deserialize(source)) ?? [];
        return this;
    }
}
